
import { useCallback } from 'react';
import { Button } from 'react-aria-components';
import { useDispatch, useSelector } from 'react-redux';
import { selectModifiedFilter } from '@pages/filter/store/selectors';
import { resetFilter, clearFilter, fillFilter } from '@pages/filter/store/slice';
import { useSaveUserDataMutation, useGetFullFilterQuery } from '@api/user/api';
import { FullFilter } from '@api/user/types/FullFilter';



interface FilterButtonsProps {
	disableModify: boolean,
}


export const FilterButtons = (props: FilterButtonsProps) => {
	const { disableModify } = props;

	const modifiedFilter = useSelector(selectModifiedFilter);
	const dispatch = useDispatch();
	const runFillFilter = (filter: FullFilter) => dispatch(fillFilter(filter))
	const runResetFilter = () => dispatch(resetFilter());
	const runClearFilter = () => dispatch(clearFilter());

	const [ saveFilter, { isLoading, isError } ] = useSaveUserDataMutation();
	const { data } = useGetFullFilterQuery();


	const handleSaveFilter = useCallback(() => {
		if (modifiedFilter) {
			saveFilter({ filter: modifiedFilter });
		}
	},[ modifiedFilter ]);

	const handleFillFilter = useCallback(() => {
		if (data) {
			runFillFilter(data);
		}
	},[ data, modifiedFilter ]);

	if (disableModify) return (
		<div className='filter-buttons'>
		</div>
	)


	return (
		<div className='filter-buttons'>
				
			<Button
				className='app-highlight-button btn'
				onPress={runClearFilter}>
					Vyčistit filtr
			</Button>

			<Button
				className='app-highlight-button btn'
				onPress={handleFillFilter}>
					Vybrat vše
			</Button>

			<Button
				className='app-highlight-button btn'
				onPress={runResetFilter}>
					Zrušit změny
			</Button>

			<Button
				className='app-highlight-button btn'
				onPress={handleSaveFilter}
				isDisabled={isLoading}>
					Uložit filtr
			</Button>

			{isError &&
				<div>Problém s načítáním dat ze serveru</div>}

		</div>
	)
}

export default FilterButtons;